//@flow
import React from 'react';
import moment from 'moment-timezone';

import { Box, Stack, Columns, Column, Text } from '@locus-taxy/neo-ui';

class MovedVisitItem extends React.PureComponent {
    render() {
        const { movedEdit } = this.props;
        const { editedOn } = movedEdit;
        const sourceBeat = movedEdit.edits[0].sourceBeatId;
        const targetBeat = movedEdit.edits[0].targetBeatId;
        return (
            <Columns alignY="center" height="fluid">
                <Column width="1/4">
                    <Text fontSize={1}>{sourceBeat}</Text>
                </Column>
                <Column width="1/4">
                    <Text fontSize={1}>{targetBeat}</Text>
                </Column>
                <Column width="content">
                    <Text fontSize={1}>
                        {moment(editedOn).format('D MMM `YY, hh:mm a z')}
                    </Text>
                </Column>
            </Columns>
        );
    }
}

export default class MovedEditsCollapseComponent extends React.PureComponent {
    render() {
        const { movedEdits, t } = this.props;
        if (!movedEdits.length) {
            return (
                <Box p={2} height="20px">
                    <Columns align="center" alignY="center" height="fluid">
                        <Column width="fluid">
                            <Text>
                                {t('entityManagement:fpPlanView.noEdits')}
                            </Text>
                        </Column>
                    </Columns>
                </Box>
            );
        }
        return (
            <Box>
                <Stack>
                    <Columns space="small">
                        <Column width="1/4">
                            <Text fontSize={2} fontWeight={600}>
                                {t(
                                    'entityManagement:fpPlanView.edits.sourceBeat'
                                )}
                            </Text>
                        </Column>
                        <Column width="1/4">
                            <Text fontSize={2} fontWeight={600}>
                                {t(
                                    'entityManagement:fpPlanView.edits.targetBeat'
                                )}
                            </Text>
                        </Column>
                        <Column width="1/2">
                            <Text fontSize={2} fontWeight={600}>
                                {t(
                                    'entityManagement:fpPlanView.edits.editedOn'
                                )}
                            </Text>
                        </Column>
                    </Columns>

                    {movedEdits.map(edit => {
                        return (
                            <MovedVisitItem
                                key={`${edit.edits.visitId}${edit.edits.sourceBeatId}`}
                                movedEdit={edit}
                            />
                        );
                    })}
                </Stack>
            </Box>
        );
    }
}
